module.exports = __webpack_public_path__ + "img/baac.6d25fd4a.svg";